<template>
  <div>
    <div class="between">
      <div class="my_text">
        <div style="color: #7d7e80; font-size: 15px; font-weight: 700">
          头像
        </div>
        <van-uploader :after-read="afterRead" accept="image/*">
            <img class="my_arrow" :src="user_img" alt="" />
        </van-uploader>
      </div>
    </div>
    <div class="between">
      <div class="my_text">
        <div style="color: #7d7e80; font-size: 15px; font-weight: 700">
          昵称
        </div>
        <input
          v-model="nichen"
          type="text"
          style="
            border: none;
            color: #5e5b5b;
            font-size: 15px;
            font-weight: 700;
            text-align: right;
          "
        />
      </div>
    </div>
    <button @click="save_data" type="submit" class="info-btn">保存</button>
  </div>
</template>

<script>
import { user_img } from "../../src/utils/request";
import { improve } from "../../src/utils/request";
import axios from "axios";
export default {
  data() {
    return {
      image: "https://qiniu.shanyu.vip/no_login.png",
      nichen: "",
      https: "",
      user_img: require("@/assets/no_login.png"), //@指的是src目录
    };
  },
  mounted() {
    this.https = axios.defaults.baseURL;
    //读取用户信息
    var user_info = JSON.parse(localStorage.getItem("user_info")); //缓存的是字符串格式的数据 需要转换为对象格式
    //设置新昵称
    this.nichen = user_info.name;
    //设置新头像
    this.user_img = user_info.userImage
      ? user_info.userImage
      : require("@/assets/no_login.png");
  },
  methods: {
    async afterRead(file) {
      const res = await user_img({
        data: {
          token: localStorage.getItem("auth_token"),
          image: file.file,
        },
      });
      this.$toast.success("上传成功");
      this.image = res.data.data;
      //设置新头像
      this.user_img = this.https + res.data.data;
      //如何向缓存中增加一个新属性？先读取 再合并 再存储
      // 1. 读取现有数据
      const storedData = localStorage.getItem("user_info");
      const parsedData = storedData ? JSON.parse(storedData) : {};
      // 2. 合并新数据
      const newData = {
        userImage: this.https + res.data.data,
      };
      const updatedData = { ...parsedData, ...newData };
      // 3. 重新存储
      localStorage.setItem("user_info", JSON.stringify(updatedData));
    },
    async save_data() {
      if (!this.nichen) {
        this.$toast("请输入昵称");
        return;
      }
      await improve({
        data: {
          nickname: this.nichen,
          token: localStorage.getItem("auth_token"),
          image: this.image,
        },
      });
      const storedData = JSON.parse(localStorage.getItem("user_info"));
      // 2. 合并新数据
      storedData.name = this.nichen;
      storedData.userImage = this.https +this.image
      const updatedData = { ...storedData };
      // 3. 重新存储
      localStorage.setItem("user_info", JSON.stringify(updatedData));
      this.$toast("修改成功");
      this.$router.back();
    },
  },
};
</script>

<style  scoped>
.between {
  line-height: 55px;
  padding-left: 10px;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid #dcdbdb;
  margin-top: 10px;
}

.van-uploader {
  height: 65px;
}

.my_text {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 0 15px;
  box-sizing: border-box;
  justify-content: space-between;
}

.my_icon {
  width: 22px;
  height: auto;
  margin-right: 20px;
}

.my_arrow {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
}
.info-btn {
  padding: 12px;
  background-color: #f0f2f5;
  color: #66b1ff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  /* cursor: pointer; */
  transition: all 0.3s;
  margin-top: 8px;
  width: 100%;
  height: 40px;
  margin-top: 120px;
}
</style>